import './button-friend-plus-drop-down.scss'

import { Skeleton } from '@acctglobal/skeleton'
import React, { useState } from 'react'

import DropDownFriendPlus from './components/DropDownFriendPlus/DropDownFriendPlus'
import ArrowIcon from '../../../../../assets/ArrowIcon'
import logoPlusFriend from '../../../../../assets/logoPlusFriend.png'
import { useClubContext } from '../../../../../contexts/ClubContext'
import { useStoreContext } from '../../../../../contexts/StoreContext'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'

interface ButtonFriendPlusProps {
  onClick?: () => void
}

const ButtonFriendPlusDropDown = ({ onClick }: ButtonFriendPlusProps) => {
  const [isShowDropDown, setIsShowDropDown] = useState(false)
  const { isLoading } = useClubContext()
  const { hasClubPlusInDropdown } = useStoreContext()
  const { isMobile } = useWindowDimensions()

  const handleClick = () => {
    setIsShowDropDown(!isShowDropDown)
    onClick?.()
  }

  if (!hasClubPlusInDropdown) {
    return null
  }

  if (isLoading) {
    return (
      <div className="buttonFriendPlus-header">
        <Skeleton
          width={isMobile ? 96 : 118}
          height={isMobile ? 24 : 32}
          margin={0}
          backgroundColor="var(--color-grayScale-faded)"
        />
      </div>
    )
  }

  return (
    <div className="buttonFriendPlus-header">
      <button
        className={`buttonFriendPlus-header-button ${isShowDropDown ? 'select' : ''}`}
        onClick={handleClick}
      >
        <img src={logoPlusFriend} alt="Logo +amigo" className="logo" />
        <ArrowIcon rotate="Down" color="var(--loyalty-color-icon-default)" />
      </button>
      {isShowDropDown && (
        <DropDownFriendPlus setIsShowDropDown={setIsShowDropDown} />
      )}
    </div>
  )
}

export default ButtonFriendPlusDropDown
